import {BaseFormModel} from '../base-form-model';

export class QuickbooksFieldMapping extends BaseFormModel<QuickbooksFieldMapping> {
    id: number;
    key: string;
    itemName: string;
    include: boolean;
    sortOrder: number;
}
